// extracted by mini-css-extract-plugin
module.exports = {"menu":"Account_menu__25mkh","section-title":"Account_section-title__3gKb0"};